<template>
  <v-container
    style="width: 80%; padding-top: 4%; padding-bottom: 7%;"
    class="text-left"
  >
    <v-card
      elevation="0"
      class="px-5 py-5 mb-5"
      color="#F5F5F5"
    >
      <div class="text-overline mb-2 body">
        ESCRÍBENOS
      </div>
      <caption class="email">info@optimalmarkets.cl</caption>
      <body-1>
        <a href="mailto:info@optimalmarkets.cl" style="text-decoration: none;">
          <v-icon color="#161c2d">mdi-email-outline</v-icon>
        </a>
      </body-1>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.body {
  color: #161c2d;
}

.email {
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 1.8rem;
  color: #161c2d;
}

</style>



// WEBPACK FOOTER //
// src/components/ContactXSmall.vue